import PropTypes from 'prop-types';
import { m } from 'framer-motion';
// @mui
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
// assets
import { ForbiddenIllustration } from 'src/assets/illustrations';
// components
import { MotionContainer, varBounce } from 'src/components/animate';
// auth
import { useAuthContext } from 'src/auth/hooks';

// ----------------------------------------------------------------------

export default function PermissionGuard({ permission, children, sx }) {
  const { hasPermission } = useAuthContext();

  if (!permission || hasPermission(permission)) {
    return <>{children}</>;
  }

  return (
    <Container component={MotionContainer} sx={{ textAlign: 'center', ...sx }}>
      <m.div variants={varBounce().in}>
        <Typography variant="h3" paragraph>
          Permission Denied
        </Typography>
      </m.div>

      <m.div variants={varBounce().in}>
        <Typography sx={{ color: 'text.secondary' }}>
          You do not have permission to access this page
        </Typography>
      </m.div>

      <m.div variants={varBounce().in}>
        <ForbiddenIllustration
          sx={{
            height: 260,
            my: { xs: 5, sm: 10 },
          }}
        />
      </m.div>
    </Container>
  );
}

PermissionGuard.propTypes = {
  children: PropTypes.node,
  permission: PropTypes.string,
  sx: PropTypes.object,
};
